import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 80px;
  padding: 0 2rem;
  color: #ffffff;
  background: linear-gradient(135deg, #254d6b 0%, #1a3a52 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;

  ul {
    display: flex;
    align-items: center;
    gap: 2rem;
    list-style-type: none;
    margin: 0;
    padding: 0;

    li {
      a {
        font-family: 'Inter', sans-serif;
        font-size: 0.9375rem;
        font-weight: 500;
        color: #ffffff;
        text-decoration: none;
        padding: 0.5rem 0;
        position: relative;
        transition: color 0.3s ease-in-out;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background-color: #27ae60;
          transition: width 0.3s ease-in-out;
        }

        &:hover {
          color: #27ae60;
          
          &::after {
            width: 100%;
          }
        }

        &.active {
          color: #27ae60;
          
          &::after {
            width: 100%;
          }
        }
      }

      @media screen and (max-width: 875px) {
        margin-right: 0;
      }
    }

    @media screen and (max-width: 1024px) {
      gap: 1.5rem;
      font-size: 0.875rem;
    }

    @media screen and (max-width: 830px) {
      width: 100%;
      justify-content: center;
      font-size: 0.8125rem;
      padding: 1rem 0;
      margin-bottom: 0.5rem;
    }
  }

  @media screen and (max-width: 760px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: auto;
    padding: 1rem;
    gap: 1rem;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.9;
  }

  img {
    height: 50px;
    width: auto;
    object-fit: contain;

    @media screen and (max-width: 875px) {
      height: 45px;
    }

    @media screen and (max-width: 760px) {
      height: 40px;
    }
  }
`;

export const CtaSubscribe = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;

  span {
    font-family: 'Inter', sans-serif;
    font-size: 0.875rem;
    font-weight: 500;
    color: #6b7280;
    white-space: nowrap;

    @media screen and (max-width: 760px) {
      font-size: 0.8125rem;
    }
  }

  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  button {
    border: none;
    padding: 0.5rem 1.25rem;
    color: #ffffff;
    cursor: pointer;
    background: linear-gradient(135deg, #27ae60 0%, #1e8e4f 100%);
    border-radius: 2rem;
    font-family: 'Inter', sans-serif;
    font-size: 0.8125rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    transition: all 0.3s ease-in-out;

    &:hover {
      background: linear-gradient(135deg, #3bc775 0%, #27ae60 100%);
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);
    }

    a {
      text-decoration: none;
      color: #ffffff;
    }
  }

  @media screen and (max-width: 875px) {
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
  }

  @media screen and (max-width: 760px) {
    flex-direction: column;
    gap: 0.5rem;
    padding: 0.5rem;
  }
`;

export const UserActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  width: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #27ae60 0%, #1e8e4f 100%);
  border: none;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: linear-gradient(135deg, #3bc775 0%, #27ae60 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 760px) {
    height: 40px;
    width: 40px;
  }
`;

export const CtaLogout = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 44px;
  padding: 0.625rem 1.25rem;
  border-radius: 2rem;
  background: linear-gradient(135deg, #27ae60 0%, #1e8e4f 100%);
  border: none;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  font-family: 'Inter', sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: linear-gradient(135deg, #3bc775 0%, #27ae60 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(39, 174, 96, 0.3);
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 875px) {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
    min-height: 40px;
  }

  @media screen and (max-width: 760px) {
    min-height: 38px;
    padding: 0.5rem 0.875rem;
  }
`;
